import React from 'react';
import PropTypes from 'prop-types';

import Field from 'zignal-landscape/lib/Field';
import Label from 'zignal-landscape/lib/Label';
import Select from 'zignal-landscape/lib/Select';
import Textarea from 'zignal-landscape/lib/Textarea';
import themeable from 'zignal-landscape/lib/themeable';
import find from 'lodash/find';

const SOURCE_TYPES = [
  {value: 'domain', label: 'Domain or URL'},
  {value: 'mediaOutlet', label: 'Media Outlet'}
];

const textAreaLabel = (sourceTypeOption) => {
  if (sourceTypeOption === 'domain') {
    return 'Domain(s) or URL(s)';
  }
  return 'Media Outlet(s)';
};

const textAreaPlaceholder = (sourceTypeOption) => {
  const commonText = 'you want to check in a new line or paste in a list copied from an email or spreadsheet';
  if (sourceTypeOption === 'domain') {
    return `Enter each domain/URL ${commonText}`;
  }
  return `Enter each media outlet (e.g. CNN) ${commonText}`;
};

const textAreaErrorMessage = (props) => {
  const { hasExceededLimit, hasDomainsCommaSeparatedValues } = props;
  if (hasExceededLimit) {
    return 'You can only check 500 domains/URLs at a time.';
  }
  if (hasDomainsCommaSeparatedValues) {
    return 'There are comma separated domains/URL\'s.';
  }
  return '';
};

const SourceCheckerForm = (props) => {
  // NOTE: "SourceType" is the 'type of Source being checked' vs. a Source Type like 'twitter', 'blogs', etc.
  const { styles, selectedSourceType, sourcesToCheck, editSourcesList,
    setSourceType } = props;

  const errorMessage = textAreaErrorMessage(props);

  const textAreaElem = selectedSourceType && (
    <Field>
      <Label>
        {textAreaLabel(selectedSourceType)}
      </Label>
      <Textarea
        rows="4"
        className={styles.checkerTextArea}
        value={sourcesToCheck}
        onChange={editSourcesList}
        placeholder={textAreaPlaceholder(selectedSourceType)}
        error={errorMessage !== ''}
        errorMessage={errorMessage}
      />
    </Field>
  );

  return (
    <div>
      <Field>
        <Label>
          Source Type
        </Label>
        <div className={styles.sourceTypeSelectContainer}>
          <Select
            options={SOURCE_TYPES}
            value={find(SOURCE_TYPES, {value: selectedSourceType})}
            placeholder="Select an option"
            onChange={(option) => setSourceType(option.value)}
            size="normal"
            showArrow
          />
        </div>
      </Field>
      <div className={styles.checkerTextAreaContainer}>
        {textAreaElem}
      </div>
    </div>
  );
};

SourceCheckerForm.propTypes = {
  styles: PropTypes.object,
  selectedSourceType: PropTypes.string,
  hasDomainsCommaSeparatedValues: PropTypes.bool,
  hasExceededLimit: PropTypes.bool,
  sourcesToCheck: PropTypes.string,
  editSourcesList: PropTypes.func,
  setSourceType: PropTypes.func,
};

export default themeable(SourceCheckerForm);
export {SOURCE_TYPES};
